var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuroPersonaFe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 88,
    viewBox: "0 0 116 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "p_fis_actemp",
    clipPath: "url(#clip0_320_285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.0535 86.2923C48.3216 75.7041 47.063 69.1142 28.3655 69.1142C9.66809 69.1142 8.38968 75.7041 1.69775 86.2923",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.3659 59.5306C38.6922 59.5306 47.0633 51.1111 47.0633 40.7251C47.0633 30.3391 38.6922 21.9196 28.3659 21.9196C18.0396 21.9196 9.66846 30.3391 9.66846 40.7251C9.66846 51.1111 18.0396 59.5306 28.3659 59.5306Z",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M102.596 63.3279H66.2998C65.6111 63.3279 64.9507 63.0526 64.4637 62.5628C63.9767 62.073 63.7031 61.4087 63.7031 60.716V4.31967C63.7031 3.62696 63.9767 2.9626 64.4637 2.47278C64.9507 1.98296 65.6111 1.7077 66.2998 1.7077H111.705C112.394 1.7077 113.054 1.98296 113.541 2.47278C114.028 2.9626 114.302 3.62696 114.302 4.31967V51.5544L102.596 63.3279Z",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M75.3691 14.3251H102.137",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M75.3691 23.3059H102.137",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M75.3691 41.2676H91.5696",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M75.3691 32.2868H102.137",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M103.116 52.0968L102.596 63.3279L114.302 51.5543L103.116 52.0968Z",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_320_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuroPersonaFe);
export default __webpack_public_path__ + "static/media/buroPersonaFE.ab778dabc1d83ab6473d31de28397c23.svg";
export { ForwardRef as ReactComponent };